import React, { Children } from 'react'
import { withStyles } from '@material-ui/core/styles'

import Scaffolding from '../scaffolding/dynamic'
import Header from '../scaffolding/widgets/header'
import Topper from '../scaffolding/widgets/topper'
import Leader from '../scaffolding/widgets/leader'
import Focuser from '../scaffolding/widgets/focuser'
import Linker from '../scaffolding/widgets/linker'

import MetaData from '../metadata'
import Footer from '../footer'
import styles from './styles'

class ServiceFocusContent extends Scaffolding {
  render() {
    const { data, metadata, policies, classes } = this.props
    const { mapper, topper, contents } = data

    this.reset()

    return (
      <div>
        <Header
          image={topper.background_image}
          video={topper.background_video}
          gradient={topper.gradient}
        />
        <div className={classes.mainFloat}>
          <Topper topper={topper} />
          <Leader topper={topper} />
          <Layout
            mapper={mapper}
            contents={contents}
            count={this.count}
            inc={this.inc}
          />
        </div>
        <Footer policies={policies} />
      </div>
    )
  }
}

const Layout = props => {
  const { mapper, contents, count, inc } = props
  return mapper.map(type => {
    switch (type) {
      case 'text':
        return (
          <Focuser contents={contents} type={type} inc={inc} count={count} />
        )
        break
      case 'content_link':
        return (
          <Linker contents={contents} type={type} inc={inc} count={count} />
        )
        break
      default:
        break
    }
  })
}

export default withStyles(styles)(ServiceFocusContent)



// WEBPACK FOOTER //
// ./src/components/servicefocus/index.js